import React from 'react';
import { Typography, MenuItem, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import FullPath from './FullPath';
const useStyles = (hierarchyLevel: number) =>
  makeStyles((theme) => ({
    level: {
      paddingLeft: theme.spacing(hierarchyLevel)
    },
    item: {
      padding: 0,
      flexFlow: 'wrap',
      width: '100%'
    }
  }));

type HierarchyOptionItemProps = {
  hierarchyLevel?: number;
  showFullPath?: boolean;
  title: string;
  fullPath?: string[];
};

export const HierarchyOptionItem: React.FC<HierarchyOptionItemProps> = ({
  hierarchyLevel = 0,
  title,
  showFullPath = false,
  fullPath = []
}: HierarchyOptionItemProps) => {
  const classes = useStyles(hierarchyLevel)();
  return (
    <MenuItem component="div" className={classes.item}>
      {showFullPath && <FullPath fullPath={fullPath} />}
      <Tooltip followCursor={true} title={title} disableInteractive>
        <Typography variant="inherit" noWrap className={classes.level}>
          {title}
        </Typography>
      </Tooltip>
    </MenuItem>
  );
};

export default HierarchyOptionItem;
